import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'
Vue.use(VueRouter)

const qilinPreviewEnabled = process.env.NODE_ENV === 'development' && process.env.VUE_APP_QILIN_PREVIEW === '1'
const qilinPreviewRoutes = new Set(['qilinPet', 'qilinCheckin', 'qilinMissions'])

const Spin = () => import(/* webpackChunkName: "route-spin" */ '../views/Spin.vue')
const Login = () => import(/* webpackChunkName: "route-login" */ '../views/Login.vue')
const Promotion = () => import(/* webpackChunkName: "route-promotion" */ '../views/Promotion.vue')
const Home = () => import(/* webpackChunkName: "route-home" */ '../views/Home.vue')
const Play = () => import(/* webpackChunkName: "route-play" */ '../views/Play.vue')
const PlayGame = () => import(/* webpackChunkName: "route-play-game" */ '../views/PlayGame.vue')
const Gift = () => import(/* webpackChunkName: "route-gift" */ '../views/Gift.vue')
const Boxs = () => import(/* webpackChunkName: "route-boxs" */ '../views/Boxs.vue')
const Register = () => import(/* webpackChunkName: "route-register" */ '../views/Register.vue')
const RegisterPass = () => import(/* webpackChunkName: "route-register-pass" */ '../views/RegisterPass.vue')
const History = () => import(/* webpackChunkName: "route-history" */ '../views/History.vue')
const Roulet = () => import(/* webpackChunkName: "route-roulet" */ '../views/Roulet.vue')
const Partner = () => import(/* webpackChunkName: "route-partner" */ '../views/Partner.vue')
const Continue = () => import(/* webpackChunkName: "route-continue" */ '../views/Continue.vue')
const Cashback = () => import(/* webpackChunkName: "route-cashback" */ '../views/Cashback.vue')
const Huay = () => import(/* webpackChunkName: "route-huay" */ '../views/Huay.vue')
const Rewards = () => import(/* webpackChunkName: "route-rewards" */ '../views/Rewards.vue')
const Gashapon = () => import(/* webpackChunkName: "route-gashapon" */ '../views/Gashapon.vue')
const WorldCupPredictor = () => import(/* webpackChunkName: "route-worldcup" */ '../views/WorldCupPredictor.vue')
const WorldCupRanking = () => import(/* webpackChunkName: "route-worldcup-ranking" */ '../views/WorldCupRanking.vue')
const QilinPet = () => import(/* webpackChunkName: "route-qilin" */ '../views/QilinPet.vue')
const QilinCheckin = () => import(/* webpackChunkName: "route-qilin" */ '../views/QilinCheckin.vue')
const QilinMissions = () => import(/* webpackChunkName: "route-qilin" */ '../views/QilinMissions.vue')

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      auth: true
    }
  },
  {
    path: '/play',
    name: 'Play',
    component: Play,
    meta: {
      auth: true
    }
  },
  {
    path: '/playgame/:key',
    name: 'Playgame',
    component: PlayGame,
    meta: {
      auth: true
    }
  },
  {
    path: '/promotion',
    name: 'promotion',
    component: Promotion,
    meta: {
      auth: true
    }
  },
  {
    path: '/partner',
    name: 'partner',
    component: Partner,
    meta: {
      auth: true
    }
  },
  {
    path: '/cashback',
    name: 'cashback',
    component: Cashback,
    meta: {
      auth: true
    }
  },
  {
    path: '/continue',
    name: 'continue',
    component: Continue,
    meta: {
      auth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/gift',
    name: 'gift',
    component: Gift
  },
  {
    path: '/boxs',
    name: 'boxs',
    component: Boxs
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/register-pass',
    name: 'register-pass',
    component: RegisterPass
  },
  {
    path: '/spin',
    name: 'spin',
    component: Spin,
    meta: {
      auth: true
    }
  },
  {
    path: '/huay',
    name: 'huay',
    component: Huay,
    meta: {
      auth: true
    }
  },
  {
    path: '/history',
    name: 'history',
    component: History,
    meta: {
      auth: true
    }
  },
  {
    path: '/roulet',
    name: 'roulet',
    component: Roulet,
    meta: {
      auth: true
    }
  },
  {
    path: '/gashapon',
    name: 'gashapon',
    component: Gashapon,
    meta: {
      auth: true
    }
  },
  {
    path: '/rewards',
    name: 'rewards',
    component: Rewards,
    meta: {
      auth: true
    }
  },
  {
    path: '/worldcup',
    name: 'worldcup',
    component: WorldCupPredictor,
    meta: {
      auth: true
    }
  },
  {
    path: '/worldcup-ranking',
    name: 'worldcupRanking',
    component: WorldCupRanking,
    meta: {
      auth: true
    }
  },
  {
    path: '/pet',
    name: 'qilinPet',
    component: QilinPet,
    meta: {
      auth: true
    }
  },
  {
    path: '/checkin',
    name: 'qilinCheckin',
    component: QilinCheckin,
    meta: {
      auth: true
    }
  },
  {
    path: '/missions',
    name: 'qilinMissions',
    component: QilinMissions,
    meta: {
      auth: true
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.onError((error: Error) => {
  const message = String(error && error.message ? error.message : error)
  const isChunkLoadError = /ChunkLoadError|Loading (CSS )?chunk [\w-]+ failed/i.test(message)
  if (!isChunkLoadError) return

  const reloadKey = 'fast28:last-chunk-reload'
  const lastReload = Number(sessionStorage.getItem(reloadKey) || 0)
  if (Date.now() - lastReload < 60000) return

  sessionStorage.setItem(reloadKey, String(Date.now()))
  window.location.reload()
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (qilinPreviewEnabled && qilinPreviewRoutes.has(String(to.name || ''))) {
      next()
      return
    }
    if (!firebase.auth().currentUser) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})
export default router
